
import BannerSection from "../BannerSection/BannerSection";
import LatestCollection from "../LatestCollection/LatestCollection";
import HomeAllProducts from "../HomeAllProducts/HomeAllProducts";
import AboutUs from "../AboutUs/AboutUs";
import ProductCat from "../ProductCat/ProductCat";
import Contact from "../Contact/Contact";
import GetInTouch from "../GetInTouch/GetInTouch";
import React, { useRef } from "react";

function MainContent() {

  const productCatRef = useRef(null);

  const scrollToProductCat = () => {
    productCatRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <BannerSection onViewMoreClick={scrollToProductCat} />
      <LatestCollection />
      <HomeAllProducts onProductCatClick={scrollToProductCat} />
      <AboutUs />
      <div ref={productCatRef}>
        <ProductCat />
      </div>
      <Contact />
      {/* <GetInTouch /> */}
    </>
  );
}

export default MainContent;
